import produce from 'immer';
import create from 'zustand';

const GRADE_STUDENTS_INITIAL = {
	// Update options
	options: {
		all: false,
		subjectId: 0,
		courseId: 0,
		startDate: '',
		endDate: '',
		additional: false
	},

	// Selected students
	selected: [],
	deselected: [],

	// Collected students
	result: {
		students: [],
		total: 0
	}
};

export const useGradeStudentsStore = create(set => ({
	...GRADE_STUDENTS_INITIAL,

	// Handle option change
	onOption: ({ name, value }) => set(produce(state => {
		state.options[name] = value;
	})),

	// Handle student state change
	onChange: ({ name, value }) => set(produce(state => {
		// console.log(state.options.all, value);
		if (state.options.all && value) {
			state.deselected = state.deselected.filter(id => id !== Number(name));
		} else if (state.options.all && !value) {
			state.deselected.push(Number(name));
		} else if (value) {
			state.selected.push(Number(name));
		} else {
			state.selected = state.selected.filter(id => id !== Number(name));
		}
	})),

	// Handle student selection
	onSelect: () => set(produce(state => {
		// Filter selected students in page
		const selectedInPage = state.selected.filter(id => state.result.students.find(s => s.student.id === id));

		// Deselect all selected students in page
		// or select all students in current page
		if (selectedInPage.length) {
			state.selected = state.selected.filter(id => !selectedInPage.includes(id));
		} else {
			state.options.all = false;
			state.deselected = [];
			state.selected = [...state.selected, ...state.result.students.map(student => student.student.id)];
		}
	})),

	// Handle all selected student deselection
	onDeselect: () => set(produce(state => {
		state.selected = [];
		state.deselected = [];
		state.options.all = false;
	})),

	// Handle all student selection and deselection
	onAll: () => set(produce(state => {
		if (state.options.all) {
			state.deselected = [];
			state.options.all = false;
		} else {
			state.selected = [];
			state.options.all = true;
		}
	})),

	// Initialize student's state
	onInit: (grades) => set({
		students: grades.map(grade => ({
			id: grade.student.id,
			avatar: grade.student.avatar,
			fullName: grade.student.fullName,
			status: grade.student.status,
			startDate: grade.startDate,
			endDate: grade.endDate,
			state: grade.state,
			checked: false
		}))
	}),

	// Initialize students grades
	onFetch: (result) => set(produce(state => {
		state.result.students = result.students;
		state.result.total = result.total;
	})),

	// Reset store softly after submit
	onAfterSubmit: () => set(produce(state => {
		// Reset options
		state.options = {
			all: false,
			subjectId: 0,
			courseId: 0,
			startDate: '',
			endDate: '',
		};

		// Reset selection state
		state.selected = [];
		state.deselected = [];
	})),

	// Reset store to initial state
	onReset: () => set({
		...GRADE_STUDENTS_INITIAL
	})
}));